$( document ).ready( function() {

  $sidebarMobile = $( '.sidebar-mobile' );
  $sidebar = $( '.sidebar-inner' );

  function getBootstrapDeviceSize() {

    return $('#device-size-detector').find('div:visible').first().attr('id');

  }

  function checkMenu(){

    var screen = getBootstrapDeviceSize();

    if( screen == "lg" ||  screen == "xl" ) {
      desktopSidebar();
    } else {
      mobileSidebar();
    }

  }

  function mobileSidebar() {

    var $reportFraud = $( '.widget.widget-report-fraud' );

    if ( $reportFraud ) {

      $reportFraud.detach();

      $sidebarMobile.append( $reportFraud );

    }

  }

  function desktopSidebar() {

    var $reportFraud = $( '.widget.widget-report-fraud' );

    if ( $reportFraud ) {

      $reportFraud.detach();

      $sidebar.append( $reportFraud );

    }

  }

  checkMenu();

  $( window ).on( 'resize', checkMenu );

});
